/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { sendGTMLoginLessBeginEvent } from '@/data/events/handlers/gtm/LoginLessBegin';
import { GTMLoginLessBeginPayload } from '@/data/types/GTM';

type LoginLessBeginDelegatorProps = {
	gtm?: GTMLoginLessBeginPayload;
};

export const loginLessBeginDelegator = async (payload: LoginLessBeginDelegatorProps) => {
	const { gtm } = payload;
	if (gtm) {
		await sendGTMLoginLessBeginEvent(gtm);
	}
};
